"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelocityOverview = void 0;
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var SafeDivide_1 = require("@CommonFrontendBackend/Utils/SafeDivide");
var ReportsVelocityDialog_1 = require("Reports/ReportsVelocityDialog/ReportsVelocityDialog");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var VelocityOverview_css_1 = require("./VelocityOverview.css");
var c = (0, BemBuilder_1.default)("velocity-overview");
var CLASSNAME_GROWTH = "growth";
var CLASSNAME_DROP = "drop";
var CLASSNAME_FAIR = "fair";
var GROWTH_METRIC_ICON = (_a = {},
    _a[CLASSNAME_GROWTH] = react_1.default.createElement(icons_1.ChevronUp, null),
    _a[CLASSNAME_DROP] = react_1.default.createElement(icons_1.ChevronDown, null),
    _a);
function VelocityGrowthIndicator(_a) {
    var className = _a.className, icon = _a.icon, growthMetric = _a.growthMetric;
    return (react_1.default.createElement("div", { className: "".concat(c("velocity-diff"), " ").concat(className) },
        icon,
        react_1.default.createElement(kaleidoscope_1.Label, { size: "m" },
            Math.round(Math.abs(growthMetric) * 100),
            "%")));
}
function VelocityOverview(props) {
    var selectedCurrency = props.selectedCurrency, pageVelocity = props.pageVelocity, previousPageVelocity = props.previousPageVelocity;
    var _a = pageVelocity || {}, _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.averagePageValue, averagePageValue = _c === void 0 ? 0 : _c, _d = _a.closeAcceptRate, closeAcceptRate = _d === void 0 ? 0 : _d, _e = _a.averageTimeLive, averageTimeLive = _e === void 0 ? 0 : _e;
    var _f = (previousPageVelocity || {}).velocity, previousVelocity = _f === void 0 ? 0 : _f;
    var velocityGrowthMetric = (0, SafeDivide_1.safeDivide)(previousVelocity - velocity, previousVelocity, 2);
    var velocityGrowthMetricClass = velocityGrowthMetric < 0 ? CLASSNAME_GROWTH : velocityGrowthMetric === 0 ? CLASSNAME_FAIR : CLASSNAME_DROP;
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("heading-row") },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "Sales velocity"),
            react_1.default.createElement(kaleidoscope_1.Popover, { caret: true, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ icon: react_1.default.createElement(icons_1.Help, { size: icons_1.IconSize.Medium, style: { color: tokens_1.palette.grey700 } }) }, buttonProps))); }, onChange: function (isOpen) {
                    if (isOpen) {
                        props.firePipelineTelemetry("velocity_metric_more_info");
                    }
                } },
                react_1.default.createElement(ReportsVelocityDialog_1.ReportsVelocityDialog, null))),
        react_1.default.createElement("div", { className: c("velocity-metric") },
            react_1.default.createElement(kaleidoscope_1.Heading, { className: "".concat(c("velocity-metric-number"), " ").concat(VelocityOverview_css_1.velocityHeadingStyle), level: "1" }, (0, FormatCurrency_1.formatCurrency)(velocity, selectedCurrency, 0).replace(/[^0-9,.]/g, "")),
            previousVelocity > 0 && (react_1.default.createElement(VelocityGrowthIndicator, { className: velocityGrowthMetricClass, icon: GROWTH_METRIC_ICON[velocityGrowthMetricClass], growthMetric: velocityGrowthMetric }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: c("velocity-details-container") },
                react_1.default.createElement("div", { className: c("avg-page-value") },
                    react_1.default.createElement(icons_1.Value, null),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Av. Page value"),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: c("metric-number") }, (0, FormatCurrency_1.formatAbbreviatedCurrency)(averagePageValue, selectedCurrency, 1, true))),
                react_1.default.createElement("div", { className: c("avg-time-live") },
                    react_1.default.createElement(icons_1.Clock, null),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Av. Time live"),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: c("metric-number") },
                        averageTimeLive,
                        " days")),
                react_1.default.createElement("div", { className: c("accept-rate") },
                    react_1.default.createElement(icons_1.Tick, null),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Accept rate"),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: c("metric-number") },
                        Math.trunc(closeAcceptRate * 10000) / 100,
                        "%"))))));
}
exports.VelocityOverview = VelocityOverview;
